import { POSTS_A } from "@/lib/blogData1";
import { POSTS_B } from "@/lib/blogData2";

export const BLOG_POSTS = [...POSTS_A, ...POSTS_B];

export const getPost = (slug) => BLOG_POSTS.find((p) => p.slug === slug);

export const getRelated = (post, count = 3) => {
    const sameCategory = BLOG_POSTS.filter(
        (p) => p.slug !== post.slug && p.category === post.category
    );
    const rest = BLOG_POSTS.filter(
        (p) => p.slug !== post.slug && p.category !== post.category
    );
    return [...sameCategory, ...rest].slice(0, count);
};
